export default __webpack_public_path__ + "static/media/main_mobile.ebc529fe.png";